export default "__VITE_ASSET__C_KO52l4__"